import React from "react";
import PropTypes from "prop-types";

export default function FermentationWarning({ mode }) {
  return (
    <div className="ferm-warning">
      {mode === "swap" ? (
        <React.Fragment>
          &#9888; This is destructive. Applying any change{" "}
          <strong>stops the current fermentation schedule</strong> &mdash; it
          cannot be resumed, only replaced.{" "}
          <strong>Temperature control is interrupted</strong> while the keg
          switches over, and the switch is driven from this browser tab. Keep
          this tab open until it finishes &mdash; if it is interrupted partway,
          the keg can be left with <strong>no temperature target at all</strong>{" "}
          until you retry.
        </React.Fragment>
      ) : (
        <React.Fragment>
          Starting fermentation takes over temperature control of the keg. It is
          driven from this browser tab &mdash; keep it open until it finishes.
        </React.Fragment>
      )}
    </div>
  );
}

FermentationWarning.propTypes = {
  mode: PropTypes.oneOf(["swap", "start"]).isRequired,
};
